import React from 'react';
import PropTypes from 'prop-types';
import Filters from './Filters.jsx';

function Toolbar({
  filterProps
}) {
  return (
    <div>
      <Filters {...filterProps} />
    </div>
  );
}

Toolbar.defaultProps = {};

Toolbar.propTypes = {
  filterProps: PropTypes.object
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Admin/Statistics/Toolbar/index.jsx